"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.adzerkHeaderBiddingUnitMap = void 0;
/**
 * File is fine, in sync with production.
 */
var adPlacements_1 = require("./adPlacements");
var readingShortInlineComments = {
    zone: 185430,
    rubiconZone: 1836690,
    pubmaticSlot: 3209054,
    sovrnTag: 830404,
    tripleliftInvCode: "wattpad_readingshort_comments_300x250_display",
    ixSiteId: "633269",
    sharethroughPKey: "cOdbdF5zhjjnC0FnoGhDuNMC",
    "33acrossSiteId": "a3NLHU9cOr7yk9rkHcnnVW",
    googleChannelId: "9845237520",
    googleAdSlot: "4695486611",
    googleMarkupFormat: "variable-width",
    lazyAd: true,
    sizes: { 5: [300, 250], 23: [320, 50] },
};
var readingShortInlineCommentsLoggedOut = {
    zone: 185437,
    rubiconZone: 1836692,
    pubmaticSlot: 3209053,
    sovrnTag: 830405,
    tripleliftInvCode: "wattpad_readingshort_comments_loggedout_300x250_display",
    ixSiteId: "633276",
    sharethroughPKey: "xvnFUSZT66r0wTcTkY04KAtL",
    "33acrossSiteId": "a8Wadm9cOr7yk9rkHcnnVW",
    googleChannelId: "7414515301",
    googleAdSlot: "4277803772",
    googleMarkupFormat: "variable-width",
    lazyAd: true,
    sizes: { 5: [300, 250], 23: [320, 50] },
};
var readingLongInlineComments = {
    zone: 185434,
    rubiconZone: 1836660,
    pubmaticSlot: 3209072,
    sovrnTag: 830384,
    tripleliftInvCode: "wattpad_desktop_readinglong_comments_300x250",
    ixSiteId: "633273",
    sharethroughPKey: "oOHplzBYyX96tpIvEgKfiKW0",
    "33acrossSiteId": "dFnVt29cKr7yk9rkHcnnVW",
    googleChannelId: "9473949854",
    googleAdSlot: "5949692685",
    googleMarkupFormat: "variable-width",
    lazyAd: true,
    sizes: { 5: [300, 250], 23: [320, 50] },
};
var readingLongInlineCommentsLoggedOut = {
    zone: 185441,
    rubiconZone: 1836662,
    pubmaticSlot: 3029071,
    sovrnTag: 830385,
    tripleliftInvCode: "wattpad_readinglong_comments_loggedout_300x250",
    ixSiteId: "633283",
    sharethroughPKey: "g9YU0UhNg0G0p7sBgtirvrR9",
    "33acrossSiteId": "dKHUQi9cKr7yk9rkHcnnVW",
    googleChannelId: "1595459833",
    googleAdSlot: "1261592348",
    googleMarkupFormat: "variable-width",
    lazyAd: true,
    sizes: { 5: [300, 250], 23: [320, 50] },
};
exports.adzerkHeaderBiddingUnitMap = (_a = {},
    _a[adPlacements_1.adPlacements.STORY_LANDING_TOP] = {
        zone: 185196,
        rubiconZone: 1836706,
        pubmaticSlot: 3209047,
        sovrnTag: 830412,
        tripleliftInvCode: "wattpad_storylanding_top_300x250",
        ixSiteId: "633264",
        sharethroughPKey: "XxS52m4zkQua1vqwB8Vcl12X",
        "33acrossSiteId": "bU-zge9cOr7yk9rkHcnnVW",
        googleChannelId: "6599540354",
        googleAdSlot: "4369303113",
        googleMarkupFormat: "variable-width",
        sizes: { 5: [300, 250] },
    },
    _a[adPlacements_1.adPlacements.STORY_LANDING_BOTTOM] = {
        zone: 185197,
        rubiconZone: 1836702,
        pubmaticSlot: 3208877,
        sovrnTag: 830410,
        tripleliftInvCode: "wattpad_storylanding_bottom_728x90_display",
        ixSiteId: "633265",
        sharethroughPkey: "QjKocE6BJDyJhIhnJeiO6DhB",
        "33acrossSiteId": "aq_1O89cOr7yk9rkHcnnVW",
        googleChannelId: "7912622023",
        googleAdSlot: "9794139742",
        googleMarkupFormat: "variable-width",
        sizes: { 4: [728, 90] },
    },
    _a[adPlacements_1.adPlacements.READING_SHORT_TOP] = {
        zone: 185429,
        rubiconZone: 1836694,
        pubmaticSlot: 3209052,
        sovrnTag: 830406,
        tripleliftInvCode: "wattpad_readingshort_top_300x250_display",
        ixSiteId: "633267",
        sharethroughPKey: "MogDMVuTk5Jd9bIQ2ZOlyHWW",
        "33acrossSiteId": "bnJq5u9cOr7yk9rkHcnnVW",
        lazyAd: true,
        googleChannelId: "3055881167",
        googleAdSlot: "6427370685",
        googleMarkupFormat: "variable-width",
        sizes: { 5: [300, 250] },
    },
    _a[adPlacements_1.adPlacements.READING_SHORT_BOTTOM] = {
        zone: 185431,
        rubiconZone: 1836682,
        pubmaticSlot: 3208867,
        sovrnTag: 830400,
        tripleliftInvCode: "wattpad_readingshort_bottom_728x90_display",
        ixSiteId: "633268",
        sharethroughPKey: "q2ixFurrAuuzN5TLWpqF0BOc",
        "33acrossSiteId": "aHVbR09cOr7yk9rkHcnnVW",
        lazyAd: true,
        isDisabled: true,
        googleChannelId: "8563945448",
        googleAdSlot: "4556719967",
        googleMarkupFormat: "default",
        sizes: { 4: [728, 90] },
    },
    _a[adPlacements_1.adPlacements.READING_SHORT_COMMENTS] = {
        zone: 185430,
        rubiconZone: 1836690,
        pubmaticSlot: 3209054,
        sovrnTag: 830404,
        tripleliftInvCode: "wattpad_readingshort_comments_300x250_display",
        ixSiteId: "633269",
        sharethroughPKey: "cOdbdF5zhjjnC0FnoGhDuNMC",
        "33acrossSiteId": "a3NLHU9cOr7yk9rkHcnnVW",
        lazyAd: true,
        refreshAd: true,
        refreshRate: 30,
        maxRefreshes: 30,
        googleChannelId: "5747028659",
        googleAdSlot: "7228234890",
        googleMarkupFormat: "variable-width",
        sizes: { 5: [300, 250], 23: [320, 50] },
    },
    _a[adPlacements_1.adPlacements.READING_SHORT_INLINE_COMMENTS] = __assign({}, readingShortInlineComments),
    _a[adPlacements_1.adPlacements.READING_LONG_TOP] = {
        zone: 185432,
        rubiconZone: 1836672,
        pubmaticSlot: 3209061,
        sovrnTag: 830395,
        tripleliftInvCode: "wattpad_readinglong_top_300x600",
        ixSiteId: "633270",
        sharethroughPKey: "8FzRfzTXlOCeH7M6BZOzMaBg",
        "33acrossSiteId": "al4kk49cOr7yk9rkHcnnVW",
        googleChannelId: "7634007155",
        googleAdSlot: "5694973018",
        googleMarkupFormat: "default",
        lazyAd: true,
        sizes: { 5: [300, 250], 43: [300, 600] },
    },
    _a[adPlacements_1.adPlacements.READING_LONG_MID] = {
        zone: 185433,
        rubiconZone: 1836664,
        pubmaticSlot: 3209069,
        sovrnTag: 830386,
        tripleliftInvCode: "wattpad_readinglong_mid_300x600",
        ixSiteId: "633271",
        sharethroughPKey: "QKEGwkCQTYAIyUpDSHO0W2B5",
        "33acrossSiteId": "d2rbD49cKr7yk9rkHcnnVW",
        googleChannelId: "4269477211",
        googleAdSlot: "8958999401",
        googleMarkupFormat: "default",
        lazyAd: true,
        refreshAd: true,
        stickyAd: true,
        stickyStart: ".sticky-ad-container",
        stickyEnd: "#sticky-end",
        sizes: { 5: [300, 250], 43: [300, 600] },
    },
    _a[adPlacements_1.adPlacements.READING_LONG_BOTTOM] = {
        zone: 185435,
        rubiconZone: 1836652,
        pubmaticSlot: 3208847,
        sovrnTag: 830380,
        tripleliftInvCode: "wattpad_readinglong_bottom_728x90_display",
        ixSiteId: "633272",
        sharethroughPKey: "QIJgn98ul3WmBcCYvVMmlTyk",
        "33acrossSiteId": "diRXWe9cKr7yk9rkHcnnVW",
        googleChannelId: "4396882998",
        googleAdSlot: "2469612676",
        googleMarkupFormat: "default",
        lazyAd: true,
        isDisabled: true,
        sizes: { 4: [728, 90] },
    },
    _a[adPlacements_1.adPlacements.READING_LONG_COMMENTS] = {
        zone: 185434,
        rubiconZone: 1836660,
        pubmaticSlot: 3209072,
        sovrnTag: 830384,
        tripleliftInvCode: "wattpad_desktop_readinglong_comments_300x250",
        ixSiteId: "633273",
        sharethroughPKey: "oOHplzBYyX96tpIvEgKfiKW0",
        "33acrossSiteId": "dFnVt29cKr7yk9rkHcnnVW",
        googleChannelId: "5326821284",
        googleAdSlot: "5863182330",
        googleMarkupFormat: "variable-width",
        lazyAd: true,
        refreshAd: true,
        refreshRate: 30,
        maxRefreshes: 30,
        sizes: { 5: [300, 250], 23: [320, 50] },
    },
    _a[adPlacements_1.adPlacements.READING_LONG_INLINE_COMMENTS] = __assign({}, readingLongInlineComments),
    _a[adPlacements_1.adPlacements.READING_SHORT_TOP_LOGGED_OUT] = {
        zone: 185436,
        rubiconZone: 1836696,
        pubmaticSlot: 3209051,
        sovrnTag: 830407,
        tripleliftInvCode: "wattpad_readingshort_top_loggedout_300x250_display",
        ixSiteId: "633274",
        sharethroughPKey: "ZzcWmSJqnINZleWJ5Cofyhqs",
        "33acrossSiteId": "btffR49cOr7yk9rkHcnnVW",
        googleChannelId: "7606905238",
        googleAdSlot: "6516954307",
        googleMarkupFormat: "variable-width",
        lazyAd: true,
        sizes: { 5: [300, 250] },
    },
    _a[adPlacements_1.adPlacements.READING_SHORT_BOTTOM_LOGGED_OUT] = {
        zone: 185438,
        rubiconZone: 1836684,
        pubmaticSlot: 3208868,
        sovrnTag: 830401,
        tripleliftInvCode: "wattpad_readingshort_bottom_loggedout_728x90_display",
        ixSiteId: "633275",
        sharethroughPKey: "Eq32H2cSDhyTGuZ44R35JwYH",
        "33acrossSiteId": "aNGTXi9cOr7yk9rkHcnnVW",
        googleChannelId: "3311618760",
        googleAdSlot: "2714274817",
        googleMarkupFormat: "default",
        lazyAd: true,
        isDisabled: true,
        sizes: { 4: [728, 90] },
    },
    _a[adPlacements_1.adPlacements.READING_SHORT_COMMENTS_LOGGED_OUT] = {
        zone: 185437,
        rubiconZone: 1836692,
        pubmaticSlot: 3209053,
        sovrnTag: 830405,
        tripleliftInvCode: "wattpad_readingshort_comments_loggedout_300x250_display",
        ixSiteId: "633276",
        sharethroughPKey: "xvnFUSZT66r0wTcTkY04KAtL",
        "33acrossSiteId": "a8Wadm9cOr7yk9rkHcnnVW",
        googleChannelId: "5873616190",
        googleAdSlot: "1494608203",
        googleMarkupFormat: "variable-width",
        lazyAd: true,
        refreshAd: true,
        refreshRate: 30,
        maxRefreshes: 30,
        sizes: { 5: [300, 250], 23: [320, 50] },
    },
    _a[adPlacements_1.adPlacements.READING_SHORT_INLINE_COMMENTS_LOGGED_OUT] = __assign({}, readingShortInlineCommentsLoggedOut),
    _a[adPlacements_1.adPlacements.READING_LONG_TOP_LOGGED_OUT] = {
        zone: 185439,
        rubiconZone: 1836676,
        pubmaticSlot: 3209059,
        sovrnTag: 830396,
        tripleliftInvCode: "wattpad_readinglong_top_loggedout_300x600",
        ixSiteId: "633277",
        sharethroughPKey: "8ZY80FZvbsxRSzlGO5O7NAS2",
        "33acrossSiteId": "aq_1O89cOr7yk9rkHcnnVW",
        googleChannelId: "5007843810",
        googleAdSlot: "4089816101",
        googleMarkupFormat: "default",
        lazyAd: true,
        sizes: { 5: [300, 250], 43: [300, 600] },
    },
    _a[adPlacements_1.adPlacements.READING_LONG_MID_LOGGED_OUT] = {
        zone: 185440,
        rubiconZone: 1836666,
        pubmaticSlot: 3209066,
        sovrnTag: 830389,
        tripleliftInvCode: "wattpad_readinglong_mid_loggedout_300x600",
        ixSiteId: "633278",
        sharethroughPKey: "R6vp0hqA96aZiblt21zGalF9",
        "33acrossSiteId": "d7KfjK9cKr7yk9rkHcnnVW",
        googleChannelId: "8017150537",
        googleAdSlot: "9150571094",
        googleMarkupFormat: "default",
        lazyAd: true,
        refreshAd: true,
        stickyAd: true,
        stickyStart: ".sticky-ad-container",
        stickyEnd: "#sticky-end",
        sizes: { 5: [300, 250], 43: [300, 600] },
    },
    _a[adPlacements_1.adPlacements.READING_LONG_BOTTOM_LOGGED_OUT] = {
        zone: 185442,
        rubiconZone: 1836654,
        pubmaticSlot: 3208848,
        sovrnTag: 830381,
        tripleliftInvCode: "wattpad_readinglong_bottom_loggedout_728x90_display",
        ixSiteId: "633282",
        sharethroughPKey: "XBM6W8A8WiI9w8jSo1l2JOgA",
        "33acrossSiteId": "dokSU69cKr7yk9rkHcnnVW",
        googleChannelId: "2409600639",
        googleAdSlot: "6158981218",
        googleMarkupFormat: "default",
        lazyAd: true,
        isDisabled: true,
        sizes: { 4: [728, 90] },
    },
    _a[adPlacements_1.adPlacements.READING_LONG_COMMENTS_LOGGED_OUT] = {
        zone: 185441,
        rubiconZone: 1836662,
        pubmaticSlot: 3029071,
        sovrnTag: 830385,
        tripleliftInvCode: "wattpad_readinglong_comments_loggedout_300x250",
        ixSiteId: "633283",
        sharethroughPKey: "g9YU0UhNg0G0p7sBgtirvrR9",
        "33acrossSiteId": "dKHUQi9cKr7yk9rkHcnnVW",
        googleChannelId: "7326869484",
        googleAdSlot: "5287347705",
        googleMarkupFormat: "variable-width",
        lazyAd: true,
        refreshAd: true,
        refreshRate: 30,
        maxRefreshes: 30,
        sizes: { 5: [300, 250], 23: [320, 50] },
    },
    _a[adPlacements_1.adPlacements.READING_LONG_INLINE_COMMENTS_LOGGED_OUT] = __assign({}, readingLongInlineCommentsLoggedOut),
    _a[adPlacements_1.adPlacements.STORY_LANDING_BOTTOM_MWEB] = {
        zone: 185453,
        rubiconZone: 1836704,
        pubmaticSlot: 3209048,
        sovrnTag: 830411,
        tripleliftInvCode: "wattpad_storylanding_bottom_mweb_320x50_display",
        ixSiteId: "633284",
        sharethroughPKey: "1KcOHnIArQcpyIsGEjdFrPlS",
        "33acrossSiteId": "bPLZvi9cOr7yk9rkHcnnVW",
        googleChannelId: "6840618473",
        googleAdSlot: "6622811805",
        googleMarkupFormat: "variable-width",
        lazyAd: true,
        sizes: { 23: [320, 50] },
    },
    _a[adPlacements_1.adPlacements.READING_SHORT_BOTTOM_MWEB] = {
        zone: 185454,
        rubiconZone: 1836688,
        pubmaticSlot: 3209055,
        sovrnTag: 830403,
        tripleliftInvCode: "wattpad_readingshort_bottom_mweb_320x50_display",
        ixSiteId: "633285",
        sharethroughPKey: "aAoKWsaAu9Li4KcewMvF1JtA",
        "33acrossSiteId": "aX2y2q9cOr7yk9rkHcnnVW",
        googleChannelId: "5554638720",
        googleAdSlot: "1185570725",
        googleMarkupFormat: "variable-width",
        lazyAd: true,
        sizes: { 23: [320, 50] },
    },
    _a[adPlacements_1.adPlacements.READING_SHORT_BOTTOM_LOGGED_OUT_MWEB] = {
        zone: 188377,
        rubiconZone: 1836686,
        pubmaticSlot: 3209056,
        sovrnTag: 830402,
        tripleliftInvCode: "wattpad_readingshort_bottom_loggedout_mweb_320x50_display",
        ixSiteId: "633286",
        sharethroughPKey: "xSsrmNSBiTVGU8MKcU3GGKU6",
        "33acrossSiteId": "aSGcz-9cOr7yk9rkHcnnVW",
        googleChannelId: "7059292087",
        googleAdSlot: "8158173182",
        googleMarkupFormat: "variable-width",
        lazyAd: true,
        sizes: { 23: [320, 50] },
    },
    _a[adPlacements_1.adPlacements.READING_LONG_MID_MWEB] = {
        zone: 185455,
        rubiconZone: 1836670,
        pubmaticSlot: 3209063,
        sovrnTag: 830393,
        tripleliftInvCode: "wattpad_readinglong_mid_mweb_300x250_display",
        ixSiteId: "633287",
        sharethroughPKey: "zoLZ0mFQzY0XxcmYCiTyngXi",
        "33acrossSiteId": "agvlmQ9cOr7yk9rkHcnnVW",
        googleChannelId: "9761461130",
        googleAdSlot: "7747109641",
        googleMarkupFormat: "default",
        lazyAd: true,
        sizes: { 5: [300, 250], 23: [320, 50] },
    },
    _a[adPlacements_1.adPlacements.READING_LONG_BOTTOM_MWEB] = {
        zone: 185456,
        rubiconZone: 1836658,
        pubmaticSlot: 3209073,
        sovrnTag: 830383,
        tripleliftInvCode: "wattpad_readinglong_bottom_mweb_320x50_display",
        ixSiteId: "633288",
        sharethroughPKey: "1FGNJtD8Tc85pnPSrx4gEk0g",
        "33acrossSiteId": "dzAGJ29cKr7yk9rkHcnnVW",
        googleChannelId: "7781346816",
        googleAdSlot: "5278774698",
        googleMarkupFormat: "variable-width",
        lazyAd: true,
        sizes: { 23: [320, 50] },
    },
    _a[adPlacements_1.adPlacements.READING_LONG_MID_LOGGED_OUT_MWEB] = {
        zone: 185457,
        rubiconZone: 1836668,
        pubmaticSlot: 3209065,
        sovrnTag: 830391,
        tripleliftInvCode: "wattpad_readinglong_mid_loggedout_mweb_300x250_display",
        ixSiteId: "633289",
        sharethroughPKey: "gSi9mMySvluqUqmiZxIcduqd",
        "33acrossSiteId": "abbtEw9cOr7yk9rkHcnnVW",
        googleChannelId: "5199415507",
        googleAdSlot: "9990129609",
        googleMarkupFormat: "default",
        lazyAd: true,
        sizes: { 5: [300, 250], 23: [320, 50] },
    },
    _a[adPlacements_1.adPlacements.READING_LONG_BOTTOM_LOGGED_OUT_MWEB] = {
        zone: 185458,
        rubiconZone: 1836656,
        pubmaticSlot: 3209074,
        sovrnTag: 830382,
        tripleliftInvCode: "wattpad_readinglong_bottom_loggedout_mweb_320x50_display",
        ixSiteId: "633290",
        sharethroughPKey: "bUMwogFn2gWL2dtnUd0Cbhga",
        "33acrossSiteId": "dthoOI9cKr7yk9rkHcnnVW",
        googleChannelId: "1096518960",
        googleAdSlot: "5095776011",
        googleMarkupFormat: "variable-width",
        lazyAd: true,
        sizes: { 23: [320, 50] },
    },
    _a[adPlacements_1.adPlacements.READING_LONG_TOP_LOGGED_OUT_MWEB] = {
        zone: 210614,
        rubiconZone: 1836678,
        pubmaticSlot: 3209058,
        sovrnTag: 830398,
        tripleliftInvCode: "wattpad_readinglong_top_loggedout_mweb_320x50_display",
        ixSiteId: "633292",
        sharethroughPKey: "lQXMBqDRaqj1i9IZH8eI3OVP",
        "33acrossSiteId": "axbcVS9cOr7yk9rkHcnnVW",
        googleChannelId: "1068598800",
        googleAdSlot: "9378921365",
        googleMarkupFormat: "variable-width",
        sizes: { 23: [320, 50] },
    },
    _a[adPlacements_1.adPlacements.READING_LONG_TOP_MWEB] = {
        zone: 210612,
        rubiconZone: 1836680,
        pubmaticSlot: 3209057,
        sovrnTag: 830399,
        tripleliftInvCode: "wattpad_readinglong_top_mweb_320x50_display",
        ixSiteId: "633293",
        sharethroughPKey: "QnWK1Js760C64KHER4S6stM6",
        "33acrossSiteId": "aCG8169cOr7yk9rkHcnnVW",
        googleChannelId: "6129353795",
        googleAdSlot: "6098399321",
        googleMarkupFormat: "variable-width",
        sizes: { 23: [320, 50] },
    },
    _a[adPlacements_1.adPlacements.READING_SHORT_TOP_LOGGED_OUT_MWEB] = {
        zone: 210613,
        rubiconZone: 1836698,
        pubmaticSlot: 3209050,
        sovrnTag: 830408,
        tripleliftInvCode: "wattpad_readingshort_top_loggedout_mweb_320x50_display",
        ixSiteId: "633295",
        sharethroughPKey: "ySrq3KmSd0iXsGdoueoIINmV",
        "33acrossSiteId": "byuQuq9cOr7yk9rkHcnnVW",
        googleChannelId: "6102251871",
        googleAdSlot: "6353302779",
        googleMarkupFormat: "variable-width",
        sizes: { 23: [320, 50] },
    },
    _a[adPlacements_1.adPlacements.READING_SHORT_TOP_MWEB] = {
        zone: 210611,
        rubiconZone: 1836700,
        pubmaticSlot: 3209049,
        sovrnTag: 830409,
        tripleliftInvCode: "wattpad_readingshort_top_mweb_320x50_display",
        ixSiteId: "633296",
        sharethroughPKey: "LWEv4YihSwUrihdu2bbDhmfc",
        "33acrossSiteId": "bEla5E9cOr7yk9rkHcnnVW",
        googleChannelId: "4061593651",
        googleAdSlot: "5231792796",
        googleMarkupFormat: "variable-width",
        sizes: { 23: [320, 50] },
    },
    _a[adPlacements_1.adPlacements.READING_SHORT_COMMENTS_MWEB] = {
        zone: 264096,
        rubiconZone: 2565820,
        pubmaticSlot: 4762047,
        tripleliftInvCode: "readingshort_comments_mweb",
        sharethroughPKey: "9y3NOPRHCwZzYrs4h5dh5a17",
        "33acrossSiteId": "bifqUe9cOr7yk9rkHcnnVW",
        googleChannelId: "1616211955",
        googleAdSlot: "5625424901",
        googleMarkupFormat: "default",
        lazyAd: true,
        sizes: { 5: [300, 250], 23: [320, 50] },
    },
    _a[adPlacements_1.adPlacements.READING_SHORT_COMMENTS_LOGGED_OUT_MWEB] = {
        zone: 264097,
        rubiconZone: 2565822,
        pubmaticSlot: 4762048,
        tripleliftInvCode: "readingshort_comments_loggedout_mweb",
        sharethroughPKey: "Gcr9Kyu1JHMOdBvTpcw7gNlG",
        "33acrossSiteId": "bcMlFs9cOr7yk9rkHcnnVW",
        googleChannelId: "1627002007",
        googleAdSlot: "6137680357",
        googleMarkupFormat: "default",
        lazyAd: true,
        sizes: { 5: [300, 250], 23: [320, 50] },
    },
    // duplicating reading short inline comment
    _a[adPlacements_1.adPlacements.READING_SHORT_INLINE_COMMENTS_MWEB] = __assign(__assign({}, readingShortInlineComments), { googleChannelId: "7765869095", googleAdSlot: "5461773378" }),
    //duplicating reading short inline comment logged out
    _a[adPlacements_1.adPlacements.READING_SHORT_INLINE_COMMENTS_LOGGED_OUT_MWEB] = __assign(__assign({}, readingShortInlineCommentsLoggedOut), { googleChannelId: "7957440780", googleAdSlot: "1330956672" }),
    _a[adPlacements_1.adPlacements.READING_LONG_COMMENTS_MWEB] = {
        zone: 264098,
        rubiconZone: 2565824,
        pubmaticSlot: 4762049,
        tripleliftInvCode: "readinglong_comments_mweb",
        sharethroughPKey: "7kMJq9mq2i0Nq02lgNIQ8zub",
        "33acrossSiteId": "dVY7YS9cKr7yk9rkHcnnVW",
        googleChannelId: "2317514567",
        googleAdSlot: "6053634462",
        googleMarkupFormat: "default",
        lazyAd: true,
        sizes: { 5: [300, 250], 23: [320, 50] },
    },
    // duplicating reading long inline comments
    _a[adPlacements_1.adPlacements.READING_LONG_INLINE_COMMENTS_MWEB] = __assign(__assign({}, readingLongInlineComments), { googleChannelId: "8620604000", googleAdSlot: "1920067890" }),
    _a[adPlacements_1.adPlacements.READING_LONG_COMMENTS_LOGGED_OUT_MWEB] = {
        zone: 264099,
        rubiconZone: 2565826,
        pubmaticSlot: 4762050,
        tripleliftInvCode: "readinglong_comments_loggedout_mweb",
        sharethroughPKey: "GYSbANPIGcCYZzpK3Cy1bSiG",
        "33acrossSiteId": "dQvUTs9cKr7yk9rkHcnnVW",
        googleChannelId: "4652620594",
        googleAdSlot: "1731246073",
        googleMarkupFormat: "default",
        lazyAd: true,
        sizes: { 5: [300, 250], 23: [320, 50] },
    },
    // duplicating reading short inline comments logged out
    _a[adPlacements_1.adPlacements.READING_LONG_INLINE_COMMENTS_LOGGED_OUT_MWEB] = __assign(__assign({}, readingLongInlineCommentsLoggedOut), { googleChannelId: "3015518562", googleAdSlot: "5775552423" }),
    _a[adPlacements_1.adPlacements.MREC_TOP] = {
        zone: 183796,
        adzerkOnly: true,
        sizes: { 5: [300, 250] },
    },
    _a[adPlacements_1.adPlacements.LIBRARY_BANNER] = {
        zone: 264755,
        rubiconZone: 2591550,
        pubmaticSlot: 4762051,
        tripleliftInvCode: "library_banner_728x90",
        sharethroughPKey: "7W4EqRAPM1wYfl7MwO3iQ5pA",
        "33acrossSiteId": "c7DUcE9cKr7yk9rkHcnnVW",
        googleChannelId: "1714879331",
        googleAdSlot: "6025714300",
        googleMarkupFormat: "default",
        sizes: { 4: [728, 90] },
    },
    _a[adPlacements_1.adPlacements.LIBRARY_BANNER_MWEB] = {
        zone: 264756,
        rubiconZone: 2591552,
        pubmaticSlot: 4762052,
        tripleliftInvCode: "library_banner_mweb_320x50",
        sharethroughPKey: "sPIyMUQe8QtYKBP0TNfP4WA7",
        "33acrossSiteId": "dbCs0A9cKr7yk9rkHcnnVW",
        googleChannelId: "8336128008",
        googleAdSlot: "3591122656",
        googleMarkupFormat: "default",
        sizes: { 23: [320, 50] },
    },
    _a[adPlacements_1.adPlacements.TAG_SEARCH] = {
        zone: 307129,
        rubiconZone: 3095518,
        pubmaticSlot: 5438698,
        tripleliftInvCode: "WattPad_tag_search_pb",
        ixSiteId: "1047898",
        sharethroughPKey: "rbRQEWIuEZUJDLuyFn1PHUU8",
        "33acrossSiteId": "aendxyBGSr7OkorkHcnlKl",
        googleChannelId: "1943034455",
        googleAdSlot: "5676048290",
        googleMarkupFormat: "default",
        sizes: {},
        responsiveSizes: {
            1132: [[160, 600]],
            1320: [
                [160, 600],
                [300, 600],
                [300, 250],
            ],
        },
    },
    _a[adPlacements_1.adPlacements.TAG_SEARCH_LOGGED_OUT] = {
        zone: 307295,
        rubiconZone: 3107700,
        pubmaticSlot: 5438698,
        tripleliftInvCode: "WattPad_tag_search_loggedout_pb",
        ixSiteId: "1047900",
        sharethroughPKey: "rbRQEWIuEZUJDLuyFn1PHUU8",
        "33acrossSiteId": "aqcHewBGSr7OkorkHcnlKl",
        googleChannelId: "4417896810",
        googleAdSlot: "1101468335",
        googleMarkupFormat: "default",
        sizes: {},
        responsiveSizes: {
            1132: [[160, 600]],
            1320: [
                [160, 600],
                [300, 600],
                [300, 250],
            ],
        },
    },
    _a[adPlacements_1.adPlacements.SEARCH] = {
        zone: 307130,
        rubiconZone: 3095520,
        pubmaticSlot: 5438695,
        tripleliftInvCode: "WattPad_Search_pb",
        ixSiteId: "1047899",
        sharethroughPKey: "w50w0qRpUPsNKbppCYIqumwR",
        "33acrossSiteId": "d7aJYEBGOr7OkorkHcnlKl",
        googleChannelId: "2962255046",
        googleAdSlot: "7027840177",
        googleMarkupFormat: "default",
        sizes: {},
        responsiveSizes: {
            1071: [[160, 600]],
            1408: [
                [300, 600],
                [160, 600],
                [300, 250],
            ],
        },
    },
    _a[adPlacements_1.adPlacements.SEARCH_LOGGED_OUT] = {
        zone: 307296,
        rubiconZone: 3107702,
        pubmaticSlot: 5438695,
        tripleliftInvCode: "WattPad_search_loggedout_pb",
        ixSiteId: "1047901",
        sharethroughPKey: "w50w0qRpUPsNKbppCYIqumwR",
        "33acrossSiteId": "akd7vYBGSr7OkorkHcnlKl",
        googleChannelId: "2591424225",
        googleAdSlot: "9478651800",
        googleMarkupFormat: "default",
        sizes: {},
        responsiveSizes: {
            1071: [[160, 600]],
            1408: [
                [300, 600],
                [160, 600],
                [300, 250],
            ],
        },
    },
    _a[adPlacements_1.adPlacements.NOTIFICATIONS_TOP] = {
        zone: 313601,
        rubiconZone: 3272384,
        pubmaticSlot: 5438698,
        tripleliftInvCode: "Wattpad_desktop_300x250_PB",
        sharethroughPKey: "OqBGb8eC2C6ejXhwzHSdagg8",
        "33acrossSiteId": "a_LuLA0Cur7OobrkHcnnVW",
        lazyAd: true,
        googleChannelId: "4898305511",
        googleAdSlot: "2176525985",
        googleMarkupFormat: "variable-width",
        sizes: {},
        responsiveSizes: {
            992: [[300, 250]],
        },
    },
    _a[adPlacements_1.adPlacements.NOTIFICATIONS_MID] = {
        zone: 313602,
        rubiconZone: 3272386,
        pubmaticSlot: 5819349,
        tripleliftInvCode: "Wattpad_desktop_300x600_PB",
        sharethroughPKey: "OxPMP0DKgPjTzG5CNObn3I75",
        lazyAd: true,
        googleChannelId: "6657082079",
        googleAdSlot: "3660998045",
        googleMarkupFormat: "variable-width",
        sizes: {},
        responsiveSizes: {
            770: [[160, 600]],
            992: [
                [300, 250],
                [300, 600],
                [160, 600],
            ],
        },
    },
    _a);
